/**
 * What the cap chip and the cap line say (20/10/2026), pure: whose cap,
 * how much a day, and what it did to this drop — cut it, or clamped it to
 * what was left.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenMasterSummary } from '@trafficpulse/shared';

const n = (x: number) => x.toLocaleString('en-US');

/** "binom's campaign group may send 20,001 SMS a day" — or the plain fact without a master. */
export function capOwnerWords(master: DropGenMasterSummary | null): string {
  if (!master) return 'The campaign group’s daily SMS cap';
  const cap = master.autoSend.dailySmsCap;
  return cap === null ? `${master.name}’s campaign group has no daily cap of its own` : `${master.name}’s campaign group may send ${n(cap)} SMS a day`;
}

export function capWords(mark: 'cut' | 'clamped', master: DropGenMasterSummary | null, plannedAmount: number | null): { title: string; body: string } {
  const owner = capOwnerWords(master);
  if (mark === 'cut')
    return {
      title: 'Cut by the daily cap — not sent today',
      body: `${owner}; the drops before this one spend it all, so this drop is not in today’s plan. Raise the cap, or send less before it.`,
    };
  return {
    title: `Clamped by the daily cap${plannedAmount !== null ? ` — ${n(plannedAmount)} SMS today` : ''}`,
    body: `${owner}; this drop takes what was left${plannedAmount !== null ? ` (${n(plannedAmount)} SMS)` : ''} and the drops after it are cut.`,
  };
}

/** The line atop Drop slots: "4 slots cut · 1 clamped by the daily cap — binom's campaign group may send 20,001 SMS a day." */
export function capLineWords(cutWords: string, master: DropGenMasterSummary | null): string {
  return `${cutWords} — ${capOwnerWords(master)}.`;
}
